import(/* webpackMode: "eager", webpackExports: ["DemoPageContent"] */ "/app/components/frontend/demo/demo-page-content.tsx");
